import { render, staticRenderFns } from "./AdBlockerDetected.vue?vue&type=template&id=850368ee&scoped=true&"
import script from "./AdBlockerDetected.vue?vue&type=script&lang=js&"
export * from "./AdBlockerDetected.vue?vue&type=script&lang=js&"
import style0 from "./AdBlockerDetected.vue?vue&type=style&index=0&id=850368ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850368ee",
  null
  
)

export default component.exports